import ic_correo from './Recursos/ic_mail.svg'
import ic_telefono from './Recursos/ic_telefono.svg'
import face from './Recursos/Iconos/ic_facebook.svg'
import insta from './Recursos/Iconos/ic_instagram.svg'
import ic_conciliacion from './Recursos/Iconos/ic_conciliacion.svg'
import ic_transito from './Recursos/Iconos/ic_transito.svg'
import ic_direccion from './Recursos/ic_direccion.svg'
import ic_animal from './Recursos/Iconos/ic_animal.png'
import ic_arbitraje from './Recursos/Iconos/ic_arbitraje.svg'
import ic_amigable from './Recursos/Iconos/ic_amigable.svg'
import ic_mediacion from './Recursos/Iconos/ic_mediacion.svg'
import ic_escolar from './Recursos/Iconos/ic_escolar.svg'
import ic_acuerdos from './Recursos/Iconos/ic_acuerdos.svg'

export const NEGRITA = "Bellefair"

export const SECCIONES = ['INICIO', 'SERVICIOS', 'NOSOTROS', 'PQRSF']

export const LINKWASS = 'https://api.whatsapp.com/send?phone=573015243727'

export const TIPOSPQRS = [

    {
        nombre: 'Peticion'
    },
    {
        nombre: 'Queja'
    },
    {
        nombre: 'Solicitud'
    },
    {
        nombre: 'Felicitacion'
    },
]

export const TIPOSPERFILACION = [

    {
        nombre: 'Insolvencia Económica'
    },
    {
        nombre: 'Conciliación'
    },
    {
        nombre: 'Arbitraje o Arbitraje Ejecutivo'
    },
    {
        nombre: 'Accidentes de Tránsito'
    },
    {
        nombre: 'Oferta Educativa'
    },
    {
        nombre: 'Otro Asunto'
    },
]

export const CONTACTOS = [
    {
        nombre: 'Telefono',
        descripcion: '+57 301 524 3727',
        img: ic_telefono,
        url: `https://api.whatsapp.com/send?phone=57${LINKWASS}`
    },
    {
        nombre: 'Correo',
        descripcion: 'cc.soluciondeconflictos22@gmail.com',
        img: ic_correo,
        url: 'mailto:cc.soluciondeconflictos22@gmail.com'
    },
    {
        nombre: 'Direccion',
        descripcion: 'Calle 14 #7-15  piso 3 Ipiales - Nariño',
        img: ic_direccion,
        url: `https://www.google.com/maps/dir/?api=1&destination=${0.8250191090320209},${-77.63980343141678},190&dir_action=navigate`
    }

]

export const TIPOSESTUDIANTES = ['Abogado u otro Profesional graduado', 'Estudiante de pregrado']

export const DIPLOMADO = {}

export const REDES = [
    {
        nombre: "facebook",
        icono: face,
        url: 'https://www.facebook.com/cc.soluciondeconflictos22'
    },
    {
        nombre: "instagram",
        icono: insta,
        url: 'https://www.instagram.com/cc.soluciondeconflictos'
    },
]


export const SERVICIOS = [

    {
        titulo: 'CONCILIACIÓN',
        items: ['Asuntos de familia', 'Civil', 'Comercial', 'Contractual', 'Convivencia y Responsabilidad Civil', 'Entre Otros'],
        icono: ic_conciliacion
    },
    {
        titulo: 'CONCILIACIÓN EN ACCIDENTES DE TRÁNSITO',
        items: [],
        icono: ic_transito
    },
    {
        titulo: 'CONCILIACIÓN EN BIENESTAR ANIMAL',
        items: [],
        icono: ic_animal
    },
    {
        titulo: 'ARBITRAJE',
        items: ['Arbitraje Institucional', 'Arbitraje Ejecutivo'],
        icono: ic_arbitraje
    },
    {
        titulo: 'AMIGABLE COMPOSICIÓN',
        items: [],
        icono: ic_amigable
    },
    {
        titulo: 'MEDIACIÓN',
        items: ['Mediación Penal'],
        icono: ic_mediacion
    },
    {
        titulo: 'MEDIACIÓN ESCOLAR',
        items: [],
        icono: ic_escolar
    },
    {
        titulo: 'ACUERDOS DE APOYO Y DIRECTIVAS ANTICIPADAS',
        items: [],
        icono: ic_acuerdos
    },
]


export const INDICADORES = [
    {
        nombre: 'Casos Conciliación',
        numero: 460
    },
    {
        nombre: 'Casos Insolvencia',
        numero: 90
    },
    {
        nombre: 'Clientes Atendidos',
        numero: 600
    }
]

export const DOCUMENTOS = [

    {
        nombre: 'RESOLUCIONES DE FUNCIONAMIENTO CONCILIACIÓN',
        url: 'https://centrodeconciliacionscpp.com/notis/recursos/conciliacion.pdf'
    },
    {
        nombre: 'RESOLUCIONES DE FUNCIONAMIENTO INSOLVENCIA',
        url: 'https://centrodeconciliacionscpp.com/notis/recursos/insolvencia.pdf'
    },
    {
        nombre: 'RESOLUCIONES DE FUNCIONAMIENTO DIPLOMADOS',
        url: 'https://centrodeconciliacionscpp.com/notis/recursos/diplomados.pdf'
    },
    {
        nombre: 'VIGILADOS POR EL MIN DE JUSTICIA Y EL DERECHO',
        url: ''
    },
    {
        nombre: 'REGISTRO OFICIAL SICAAC',
        url: ''
    },
]

export const PREGUNTAS = [
    {
        pregunta: '¿CUÁNTO TIEMPO TOMA UN TRÁMITE DE CONCILIACIÓN?',
        respuesta: 'Por ley, el trámite completo toma entre 15 días y un mes como máximo, desde la admisión de la solicitud.'
    },
    {
        pregunta: '¿QUIÉNES PUEDEN ACTUAR COMO CONCILIADORES DEL CENTRO?',
        respuesta: 'Profesionales del derecho titulados, que cuenten con la certificación de la formación como conciliadores avalados por el Ministerio de Justicia y con registro activo en el sistema SICAAC.'
    },
    {
        pregunta: '¿QUÉ MATERIAS TIENEN PROHIBICIÓN EXPRESA DE CONCILIAR?',
        respuesta: 'En nuestro Centro de Conciliación no podemos conciliar los derechos de carácter personalísimo, materias penales no querellables, algunos asuntos penales, asuntos de nulidad absoluta y ciertos temas por competencia específica como materia laboral y controversias directas con el Estado.'
    },
]

export const TESTIMONIOS = [
    {
        nombre: 'Dra. María Elena Restrepo, Asesora Legal Empresarial',
        img: '',
        descripcion: '"La implementación del Arbitraje Ejecutivo bajo la Ley 2540 de 2025 en este centro ha sido clave para nuestra firma. Logramos decretar medidas cautelares y recuperar cartera pesada en semanas, evitando los años de espera del juzgado."'
    },
    {
        nombre: 'Dr. Alejandro Benavides, Director de Litigios Jurídicos',
        img: '',
        descripcion: '"Tramitar los procesos de insolvencia de forma 98% virtual con este centro nos da una ventaja competitiva enorme. La agilidad en la admisión del trámite frena de inmediato los embargos de nuestros clientes a nivel nacional."'
    },
    {
        nombre: 'Dra. Liliana Castro, Especialista en Derecho de Familia y Contratos',
        img: '',
        descripcion: '"Es nuestro centro privado de confianza. Las actas de conciliación que tramitamos aquí se emiten en menos de un mes, con un rigor jurídico impecable y pleno mérito ejecutivo, garantizando la total tranquilidad de las partes."'
    }
]

export const ENALCES = [
    {
        nombre: 'POLITICAS DE PRIVACIDAD'

    },
]